import React from "react";
import "./ComingSoon.css";

export default function ComingSoon() {
  return (
    <div className="coming-hero">

      {/* Background Image */}
      <img 
        src="/comingsoon.png"
        alt="UrbanScore Coming Soon"
        className="hero-bg"
      />

      {/* Overlay for blur & darkening */}
      <div className="hero-overlay"></div>

      {/* Centered Text */}
      <div className="hero-content">
        <h1>Coming Soon</h1>
        <p>Our next-generation UrbanScore platform is almost ready.</p>
      </div>

    </div>
  );
}
